import { render } from "./ListItemNoticia.vue?vue&type=template&id=04bab3e2&scoped=true"
import script from "./ListItemNoticia.vue?vue&type=script&lang=js"
export * from "./ListItemNoticia.vue?vue&type=script&lang=js"

import "./ListItemNoticia.vue?vue&type=style&index=0&id=04bab3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bab3e2"]])

export default __exports__